import React from "react";
import clsx from "clsx/lite";
import verticalSpacing from "utils/generate-vertical-spacing";
import Hero from "components/hero";
import RichText from "components/rich-text";
import FeaturedCollection from "components/featured-collection";
import CategoryMenu from "components/category-menu";
import BlogPosts from "components/blog-posts";
import MediaCarousel from "components/media-carousel";
import CollectionsAccordions from "components/collections-accordions";
import CustomReviews from "components/custom-reviews";
import InstaGallery from "components/insta-gallery";
import Newsletter from "components/newsletter";
import Accordions from "components/accordions";
import MediaWithTextGroup from "components/media-with-text-group";
import OkendoReviewsWidget from "components/okendo/reviews-widget";
import OkendoMediaGrid from "components/okendo/media-grid";
import OkendoReviewsCarousel from "components/okendo/reviews-carousel";
import Wishlist from "components/wishlist";
import Iframe from "components/iframe";
import Cards from "components/cards";
import FeaturedBlogs from "components/featured-blogs";
import LoyaltyLion from "components/loyalty-lion";
import ModProForm from "components/mod-pro";
import CollectionList from "components/collection-list";
import CardsCarousel from "components/cards-carousel";
import DiscountCodes from "components/discount-codes";
import BannerImage from "components/banner-image";
import MalomoOrderTracking from "components/order-tracking";
import SecureCheckout from "components/secure-checkout";
import SimilarProducts from "components/similar-products";
import ContactForm from "components/contact-form";
import ImageModule from "components/image-module";
import RecentlyViewed from "components/recently-viewed";
import WarrantyActivationForm from "components/warranty-activation-form";
import ContactInfo from "components/contact-info";
import Catalog from "components/catalog";
import SmsSubscription from "components/sms-subscription";
import CatalogPromo from "components/catalog-promo";
import ImageGrid from "components/image-grid";
import ProductDetails from "components/product-details";
import InfoCarousel from "components/info-carousel";
import ImageAssociatedText from "components/image-associated-text";
import OctaneQuiz from "components/octane-quiz";
import OkendoBadge from "../okendo/badge";
import EmbeddedSearch from "components/embedded-search";
import VideoModule from "components/video-module";

const _module2Component = {
	hero: Hero,
	mediaCarousel: MediaCarousel,
	richTextModule: RichText,
	featuredCollection: FeaturedCollection,
	categoryMenu: CategoryMenu,
	blogPosts: BlogPosts,
	collectionsAccordions: CollectionsAccordions,
	customReviews: CustomReviews,
	instaGallery: InstaGallery,
	newsletter: Newsletter,
	accordions: Accordions,
	mediaWithTextGroup: MediaWithTextGroup,
	okendoReviews: OkendoReviewsWidget,
	okendoMediaGrid: OkendoMediaGrid,
	okendoBadge: OkendoBadge,
	okendoReviewsCarousel: OkendoReviewsCarousel,
	wishlist: Wishlist,
	iframe: Iframe,
	cards: Cards,
	loyaltyLion: LoyaltyLion,
	featuredBlogs: FeaturedBlogs,
	modProForm: ModProForm,
	collectionList: CollectionList,
	cardsCarousel: CardsCarousel,
	discountCodes: DiscountCodes,
	bannerImage: BannerImage,
	orderTracking: MalomoOrderTracking,
	secureCheckout: SecureCheckout,
	similarProducts: SimilarProducts,
	contactForm: ContactForm,
	imageModule: ImageModule,
	recentlyViewed: RecentlyViewed,
	warrantyActivationForm: WarrantyActivationForm,
	contactInfo: ContactInfo,
	catalog: Catalog,
	smsSubscription: SmsSubscription,
	catalogPromo: CatalogPromo,
	imageGrid: ImageGrid,
	productDetails: ProductDetails,
	infoCarousel: InfoCarousel,
	imageAssociatedText: ImageAssociatedText,
	octaneQuiz: OctaneQuiz,
	embeddedSearch: EmbeddedSearch,
	videoModule: VideoModule,
};

const Module = ({ module, ...other }) => {
	const settings = module.settings || {};
	if (settings.isHidden) return null;

	const variation = settings.variation !== "none" ? settings.variation : null;

	const RequestedModule = _module2Component[module._type];
	const bgColor = settings.bgColor?.hex;
	const isVerticalSpaceOutside = settings.isVerticalSpaceOutside;

	const containerBgColor = isVerticalSpaceOutside ? bgColor : null;
	const sectionBgColor = !isVerticalSpaceOutside ? bgColor : null;

	const bgImage = module.backgroundImage && {
		backgroundImage: `url(${module.backgroundImage})`,
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover",
		backgroundPosition: "center",
	};

	return RequestedModule ? (
		<section
			style={{ backgroundColor: sectionBgColor, ...bgImage }}
			className={clsx(verticalSpacing(settings.verticalSpace), variation && `${variation} ${module._type}`, "w-full")}>
			<div
				style={{ backgroundColor: containerBgColor }}
				className={
					clsx(settings.isFluid ? "w-full" : "container-fluid-padding",
						isVerticalSpaceOutside && bgColor && "py-4 md:py-6"
					)}>
				<RequestedModule data={module} {...other} />
			</div>
		</section>
	) : null;
};

export default Module;
